import {ChangeDetectionStrategy, Component} from "@angular/core";

@Component({
    selector: "wbo-search-grid-header",
    template: "<ng-content></ng-content>",
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchGridHeaderComponent {
}
